import { IonContent, IonInput, IonPage, IonText,IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState,useMemo } from "react"
import { Modal } from "react-bootstrap"
import { useHistory } from "react-router"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Head from "../Header"
import Sidebar from "../Sidebar"
import swal from 'sweetalert';

const ParentActivityMeta: React.FC = () => {
      const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
          history.push("/login");
        } else {
        }
      }, [token, history]);
      const [data, setData]: any = useState([]);

      const [filterText, setFilterText] = useState("");
      const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
      const [createdBy] = useState(localStorage.getItem("SignupEmpId"));
      const [loading,setloading]=useState(false)
      data.forEach((item: any, index: any) => { item.serial = index + 1; });

      /*......................Create............... */

      const [activity, setActivity] = useState("");
      const [activityDescription, setActivityDescription] = useState("");
      const [modalOpen, setModalOpen] = useState(false);

      /*....................... View ............... */

      const [activityName, setActivityName] = useState("");
      const [description, setDescription] = useState("");
      const [modalOpen1, setModalOpen1] = useState(false);


      const columns: any = [
            {
                  name: "S.No",
                  selector: (itm: any, i: any) => itm.serial,
                  sortable: false,
                  width: "150px",
            },
            {
                  name: "Name",
                  selector: (itm: any) => itm.parentActivity,
                  sortable: true,
                  width: "450px",
            },
            {
                  name: "Description",
                  selector: (itm: any) => itm.parentActivityDesc,
                  sortable: true,
                  width: "450px",
            },
            {
                  name: "View",
                  sortable: false,
                 
                  cell: (itm: any) => (
                        <>
                              <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                                    <IonText style={{ color: "coral", cursor: 'pointer' }} onClick={() => openmodal(itm)} >View</IonText>
                              </div>
                        </>
                  )
            }

      ];

      const paginationComponentOptions = {
            selectAllRowsItem: true,
            selectAllRowsItemText: "ALL"
      };
      const subHeaderComponent = useMemo(() => {
            const handleClear = () => {
                if (filterText) {
                    setResetPaginationToggle(!resetPaginationToggle);
                    setFilterText("");
                }
            
            };
        
        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )
        
        }, [filterText, resetPaginationToggle]);

      const tabledata = data.filter(
            (item: any) =>
                  JSON.stringify(item)
                        .toLowerCase()
                        .indexOf(filterText.toLowerCase()) !== -1
      );

      useEffect(() => {
            View();
      }, []);

      const View = () => {
            setloading(true);
            service.GetAllParentActivity()
                .then((response) => {
                    console.log(response.data);
                    if (response.data.Status === "200") {
                        setData(response.data.Data);
                    } else {
                        setData([]);
                    }
                })
                .catch((error) => {
                    swal(error);
                })
                .finally(() => {
                    // This code will execute whether the promise is resolved or rejected
                    setTimeout(() => {
                        setloading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                    }, 500); // Adjust the timeout duration as needed
                });
        };

      const customStyles = {
            headRow: {
                  style: {
                  },
            },
            headCells: {
                  style: {
                        fontWeight: "800",
                        fontSize: "15px",

                  },
            },
            cells: {
                  style: {
                        fontSize: "15px"
                  }
            }
      };

      const openmodal = (itm: any) => {
            service.GetParentActivityById(itm.id)
                  .then((response) => {
                        console.log(response);
                        if (response.data.Status === "200") {
                              setActivityName(response.data.Data.parentActivity)
                              setDescription(response.data.Data.parentActivityDesc)
                              setModalOpen1(true)
                        }
                        else {
                              setActivityName("")
                              setDescription("")
                              setModalOpen1(true)
                        }
                  })
      }

      const closemodal = () => {
            setModalOpen(false);
            setActivity("");
            setActivityDescription("");
      }

      const Create = () => {
            if (activity.length == 0) {
                  swal("", "Please Enter Activity Name", "info");
            }
            else if (activityDescription.length == 0) {
                  swal("", "Please Enter Activity Description", "info");
            }
            else {
                  service.ParentActivitySave(activity, activityDescription, createdBy)
                        .then((response) => {
                              console.log(response);
                              if (response.data.Status === "200") {
                                    swal("", "Created Successfully", "success");
                                    window.location.reload();
                              }
                              else {
                                    swal("", response.data.Message, "info");
                              }
                        })
            }
      }

      const closemodal1 = () => {
            setModalOpen1(false)
            setActivityName("");
            setDescription("")
      }
      const back = () => {
            history.goBack();
        }
      return (
            <IonPage>
                  <Head />
                  <Sidebar />
                  <IonContent>
                        <div className="page-wrapper">
                              <div className="page-header">
                                    <div className="content container-fluid">
                                          <div className="row align-items-center">
                                                <div className="col">
                                                      <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                                      <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                                            Parent Activity</h3>
                                                </div>
                                                <div className="col-auto float-end ml-auto">
                                                      <a onClick={() => setModalOpen(true)} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Parent Activity</a>
                                                </div>
                                          </div>
                                          {loading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                                          <div className="table-responsive" style={{ marginTop: "1%" }}>
                                                <DataTable
                                                      columns={columns}
                                                      data={tabledata}
                                                      pagination
                                                      paginationPerPage={10}
                                                      paginationComponentOptions={paginationComponentOptions}
                                                      paginationRowsPerPageOptions={[10, 20, 30]}
                                                      subHeader
                                                      subHeaderComponent={subHeaderComponent}
                                                      customStyles={customStyles}
                                                />
                                          </div>
                                    </div>
                              </div>
                        </div>

                        {/* ...........................Create Parent Activity.................... */}

                        <Modal
                         dialogClassName="modal-dialog modal-lg"
                              // id="logouts-modal"
                              show={modalOpen}
                        >
                              <div className="modal-header">
                                    <h5 className="modal-title">Create Parent Activity</h5>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                          <span aria-hidden="true">×</span>
                                    </button>
                              </div>
                              <div className="modal-body">
                                    <form>
                                          <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Activity Name <span className="text-danger">*</span></label>
                                                <div>
                                                      <IonInput value={activity} onIonChange={(e: any) => setActivity(e.detail.value)} className="form-control datetimepicker" />
                                                </div>
                                          </div>
                                          <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Activity Description <span className="text-danger">*</span></label>
                                                <div>
                                                      <IonInput value={activityDescription} onIonChange={(e: any) => setActivityDescription(e.detail.value)} className="form-control datetimepicker" />
                                                </div>
                                          </div>
                                          <div className="submit-section">
                                                <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                                          </div>
                                    </form>
                              </div>
                        </Modal>

                        {/* ............................ View Parent Activity .................... */}

                        <Modal
                         dialogClassName="modal-dialog modal-lg"
                              show={modalOpen1}
                        >
                              <div className="modal-header">
                                    <h5 className="modal-title">View Parent Activity</h5>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                                          <span aria-hidden="true">×</span>
                                    </button>
                              </div>
                              <div className="modal-body">
                                    <form>
                                          <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Activity Name <span className="text-danger">*</span></label>
                                                <div>
                                                      <IonInput value={activityName} disabled className="form-control datetimepicker" />
                                                </div>
                                          </div>
                                          <div className="form-group">
                                                <label style={{ fontWeight: "bold" }}>Activity Description <span className="text-danger">*</span></label>
                                                <div>
                                                      <IonInput value={description} disabled className="form-control datetimepicker" />
                                                </div>
                                          </div>
                                          <div className="submit-section">
                                                <button type="button" className="btn-primary submit-btn" onClick={() => closemodal1()}>Back</button>
                                          </div>
                                    </form>
                              </div>
                        </Modal>


                  </IonContent>
            </IonPage>
      )
}

export default ParentActivityMeta;